export const PAGER_WINDOW = 10;

export type SortDir = 'asc' | 'desc';

export function pagerPageIndexes(current: number, total: number, window = PAGER_WINDOW): number[] {
  if (total <= 0) return [];
  const start = Math.max(0, current - window);
  const end = Math.min(total - 1, current + window);
  const pages: number[] = [];
  for (let i = start; i <= end; i += 1) pages.push(i);
  return pages;
}

export function sortQuery(field: string, dir: SortDir): string {
  if (field === 'fecha') return `&sort=fecha,${dir}&sort=hora,${dir}`;
  if (field === 'asunto') return `&sort=asunto.codigo,${dir}`;
  if (field === 'concepto') return `&sort=concepto.codigo,${dir}`;
  return `&sort=${encodeURIComponent(field)},${dir}`;
}

export function formatBuzonFecha(fecha?: string | null): string {
  if (!fecha) return '';
  const iso = /^(\d{4})-(\d{2})-(\d{2})/.exec(fecha);
  if (iso) return `${iso[3]}/${iso[2]}/${iso[1]}`;
  return fecha;
}

export function formatBuzonHora(hora?: string | null): string {
  if (!hora) return '';
  const hm = /^(\d{1,2}):(\d{2})(?::\d{2})?/.exec(hora);
  if (hm) return `${hm[1].padStart(2, '0')}:${hm[2]}`;
  return hora;
}

export function parseBuzonPage(raw: string | null | undefined): number {
  const n = Number(raw);
  if (!Number.isFinite(n) || n < 1) return 1;
  return Math.floor(n);
}

export function toApiPage(oneBased: number): number {
  return Math.max(0, oneBased - 1);
}

export function normalizeBuzonRfc(value: string): string {
  return value.trim().toUpperCase();
}

export function normalizeBuzonConcepto(value: string | null | undefined): string {
  return (value ?? '').trim().toUpperCase();
}

export function normalizeBuzonAsunto(value: string | null | undefined): string {
  return normalizeBuzonConcepto(value);
}

export type BuzonVista = 'buzon' | 'fallos';

export function isBuzonFallosView(view: string | null | undefined): boolean {
  return view === 'fallos' || view === 'fallos-nuevos' || view === 'fallos-descartados';
}

export function parseBuzonVista(vista: string | null | undefined, view?: string | null): BuzonVista {
  if (vista === 'fallos') return 'fallos';
  if (vista === 'buzon') return 'buzon';
  return isBuzonFallosView(view) ? 'fallos' : 'buzon';
}
